import { render } from "./RegistrationLastName.vue?vue&type=template&id=3acacb3a&scoped=true&ts=true"
import script from "./RegistrationLastName.vue?vue&type=script&lang=ts"
export * from "./RegistrationLastName.vue?vue&type=script&lang=ts"

import "./RegistrationLastName.vue?vue&type=style&index=0&id=3acacb3a&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acacb3a"]])

export default __exports__